import { Injectable, inject } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import {
  barrierefreiheitOptions,
  FacettenOptionInfoBarrierefreiheit
} from '../../../model/barrierefreiheit';
import { FacettenService } from '../facetten.service';
import { BarrierefreiheitUrlService } from './barrierefreiheiturl.service';

@Injectable({
  providedIn: 'root'
})
export class BarrierefreiheitService extends FacettenService {
  constructor() {
    const urlService = inject(BarrierefreiheitUrlService);

    super(urlService, AggregationKey.Barrierefreiheit, barrierefreiheitOptions);
  }

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.getFacetteOptions$(),
      this.facettenUrlService.selectedOptionIds$
    ]).pipe(
      map(([facetteOptions, ids]) => {
        return (this.orderedOptions as FacettenOptionInfoBarrierefreiheit[]).map(
          ({ id, bezeichnung, backendId }) => {
            const anzahl =
              facetteOptions.find((option) => option.id === backendId.toString())?.anzahl ?? 0;
            const isSelected = this.isItemSelected(ids, backendId.toString());
            const item = {
              key: id.toString(),
              ariaLabel: bezeichnung,
              treffer: anzahl,
              label: bezeichnung,
              selected: isSelected,
              active: anzahl > 0
            };
            return item;
          }
        );
      })
    );
  }
}
